import DesktopChangesView from "../../../../content/images/desktop-changesview.png";
import * as React from 'react';
export default {
  DesktopChangesView,
  React
};